import { CtaBandSection } from './cta-band-section';
import { TenantFaqSection } from '@/components/tenant-faq/tenant-faq-section';
import { HeroSection } from './hero-section';
import { HowItWorksSection } from './how-it-works-section';
import { ProductSection } from './product-section';
import { TrustSection } from './trust-section';
import { UseCasesSection } from './use-cases-section';

interface MiloraLandingContentProps {
  isAuthenticated: boolean;
}

export function MiloraLandingContent({ isAuthenticated }: MiloraLandingContentProps) {
  return (
    <>
      <HeroSection isAuthenticated={isAuthenticated} />
      <ProductSection />
      <HowItWorksSection />
      <UseCasesSection />
      <CtaBandSection isAuthenticated={isAuthenticated} />
      <TrustSection />
      <TenantFaqSection
        title="Frequently asked questions"
        description="Quick answers for community owners evaluating Milora."
      />
    </>
  );
}
